export default function sortLeadership(combinedNodes) {
    return combinedNodes.sort((a, b) => {
        // Sort the top leadership first
        if (a.field_top_leadership && !b.field_top_leadership) {
            return -1;
        }
        // If there are multiple top leadership, sort the higher featured weights before the lower feature weights
        if (
            a.field_featured_weight > b.field_featured_weight &&
            a.field_top_leadership &&
            b.field_top_leadership
        ) {
            return -1;
        }
        // Sort top leadership before any featured weight.
        if (
            a.field_featured_weight > b.field_featured_weight &&
            !b.field_top_leadership
        ) {
            return -1;
        }
        // Sort the higher feature weights before the lower feature weights
        else if (a.field_featured_weight < b.field_featured_weight) {
            return 1;
        }
        // Keep the alphabetical order of last name provided by the query
        else {
            return 0;
        }
    });
}
